import Base from './base'

export default class MelodyReminders extends Base {
  index() {
    return this.api.get('reminders.json')
  }

  create(body) {
    return this.api.post('reminders.json', body)
  }

  complete(id) {
    return this.api.put(`reminders/${id}/complete.json`)
  }
}
